import './lib/sentry';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { configureAmplify } from './lib/amplify';

// Initialize AWS Amplify before rendering
configureAmplify();

// Security: Disable React DevTools in production
if (import.meta.env.PROD) {
  const hook = window.__REACT_DEVTOOLS_GLOBAL_HOOK__;
  if (hook && typeof hook === 'object') {
    for (const prop of Object.keys(hook)) {
      const key = prop as keyof typeof hook;
      (hook as Record<string, unknown>)[key] = typeof hook[key] === 'function'
        ? () => undefined
        : null;
    }
  }
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
